import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55da596a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "Info_Modal"
}
const _hoisted_2 = {
  key: 1,
  class: "Info_Modal_Content"
}
const _hoisted_3 = { class: "Info_Modal_Main" }
const _hoisted_4 = {
  class: "bold",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_5 = { class: "Info_Contents" }
const _hoisted_6 = { class: "info_tit js-info_accodion" }
const _hoisted_7 = { class: "info_date" }
const _hoisted_8 = { class: "info_txt" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "Info_Modal_BtnBlock" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px"} }, "(今後表示しない)", -1))
const _hoisted_13 = { class: "Dashboard_Container_Flex" }
const _hoisted_14 = { class: "Dashboard_Contents" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Dashboard_Contents_Title" }, "お知らせ", -1))
const _hoisted_16 = {
  key: 0,
  class: "Dashboard_Contents_Main"
}
const _hoisted_17 = {
  key: 0,
  class: "ResultMessageNull",
  style: {"background":"#fff"}
}
const _hoisted_18 = {
  key: 1,
  class: "Info_Container"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "info_tit js-info_accodion" }
const _hoisted_21 = { class: "info_date" }
const _hoisted_22 = { class: "info_txt" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "Dashboard_Left" }
const _hoisted_25 = { class: "Dashboard_Contents" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Dashboard_Contents_Title" }, "バッチ処理状況", -1))
const _hoisted_27 = {
  key: 0,
  class: "Dashboard_Contents_Main"
}
const _hoisted_28 = { class: "Table_Container" }
const _hoisted_29 = { class: "Dashboard_Table" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th", null, "対象データ"),
    /*#__PURE__*/_createElementVNode("th", null, "バッチ挙動"),
    /*#__PURE__*/_createElementVNode("th", null, "状況")
  ])
], -1))
const _hoisted_31 = {
  key: 0,
  class: "Dashboard_Container_Flex"
}
const _hoisted_32 = { class: "Dashboard_Right" }
const _hoisted_33 = { class: "Dashboard_Contents" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "Dashboard_Contents_Title" }, "操作ログ", -1))
const _hoisted_35 = {
  key: 0,
  class: "Dashboard_Contents_Main"
}
const _hoisted_36 = { class: "Table_Container" }
const _hoisted_37 = { class: "Dashboard_Table" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th", null, "更新内容"),
    /*#__PURE__*/_createElementVNode("th", null, "更新者"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_39 = { style: {"border-bottom":"1px solid rgb(175, 175, 175)"} }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "ResultMessageNull",
  style: {"background":"#fff"}
}

import { computed, onBeforeUnmount, ref } from "vue";
import { useStore } from "vuex";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import axios, { AxiosResponse } from "axios";
import { Notyf } from "notyf";
import { useRouter } from "vue-router";
import BtnGreen from "@/components/atoms/button/BtnGreen.vue";

interface BatchSchedule {
  hanmotoCd: string;
  // 出力・取込状況
  isFetchedSyosi: number;
  isFetchedSyukko: number;
  isOutputtedAddSyosi: number;
  isFetchedToritugi: number;
  isFetchedShinagire: number;
  isOutputtedShinagireKaijo: number;
  isOutputtedJuchu: number;
  isFetchedChosei: number;
  isOutputtedChosei: number;
  quarterTorioki: number;
  quarterZaiko: number;
  isFetchedHenpinDenpyou: number;
  isFetchedNouhinenpyou: number;
  // 実行時間
  syosiUpdatedAt: string | null;
  syukkoUpdatedAt: string | null;
  addSyosiUpdatedAt: string | null;
  toritugiUpdatedAt: string | null;
  shinagireUpdatedAt: string | null;
  shinagireKaijoUpdatedAt: string | null;
  juchuUpdatedAt: string | null;
  choseiFetcheUpdatedAt: string | null;
  choseiOutputUpdatedAt: string | null;
  toriokiUpdatedAt: string | null;
  zaikoUpdatedAt: string | null;
  henpinDenpyouUpdatedAt: string | null;
  nouhinDenpyouUpdatedAt: string | null;
  // キー
  [key: string]: string | number | null;
}

interface ShowBatchSchedule {
  date: string;
  dataName: string;
  behavior: string;
  statusNumber: number;
  statusName: string;
}

// 各項目の表示制御---------------------------------------------
// バッチ処理状況
type BatchInfo = typeof batchInfo;

const ms = 30000;
// タイマーストップ
type OperationLogList = typeof operationLogList.value[0];
type HeadlineGroup = typeof headlineGroup[0];
type InformationList = typeof latestInformation.value[0];

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardPage',
  props: {
  isActive_SidebarFlg: { type: Boolean },
  currentPathList: [{ name: String }],
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props, { emit: __emit }) {

const notyf = new Notyf();

const props = __props;
const store = useStore();
const router = useRouter();

const emit = __emit;
emit("showGlobalHeader");

// 型定義------------------------------------------------------
let isActiveBatch = ref(true);
const toggleBatchArea = (): void => {
  isActiveBatch.value = !isActiveBatch.value;
};
// 操作ログ
let isActiveCalendar = ref(true);
const toggleCalendarArea = (): void => {
  isActiveCalendar.value = !isActiveCalendar.value;
};
// お知らせ
let isActiveInfo = ref(true);
const toggleInfoArea = (): void => {
  isActiveInfo.value = !isActiveInfo.value;
};

// バッチスケジュールの取得--------------------------------------
const batchSchedule = ref([] as ShowBatchSchedule[]);
const batchInfo = {
  isFetchedSyosi: function () {
    return {
      dataName: "書誌データ",
      behavior: "取込",
      dateKey: "syosiUpdatedAt",
    };
  },
  isFetchedSyukko: function () {
    return {
      dataName: "出庫データ",
      behavior: "取込",
      dateKey: "syukkoUpdatedAt",
    };
  },
  isOutputtedAddSyosi: function () {
    return {
      dataName: "追加書誌データ",
      behavior: "出力",
      dateKey: "addSyosiUpdatedAt",
    };
  },
  isFetchedToritugi: function () {
    return {
      dataName: "取次書店データ",
      behavior: "取込",
      dateKey: "toritugiUpdatedAt",
    };
  },
  isFetchedShinagire: function () {
    return {
      dataName: "品切保留データ",
      behavior: "取込",
      dateKey: "shinagireUpdatedAt",
    };
  },
  isOutputtedShinagireKaijo: function () {
    return {
      dataName: "品切保留解除データ",
      behavior: "出力",
      dateKey: "shinagireKaijoUpdatedAt",
    };
  },
  isOutputtedJuchu: function () {
    return {
      dataName: "受注データ",
      behavior: "出力",
      dateKey: "juchuUpdatedAt",
    };
  },
  isFetchedChosei: function () {
    return {
      dataName: "調整データ",
      behavior: "取込",
      dateKey: "choseiFetcheUpdatedAt",
    };
  },
  isOutputtedChosei: function () {
    return {
      dataName: "調整データ",
      behavior: "出力",
      dateKey: "choseiOutputUpdatedAt",
    };
  },
  quarterTorioki: function () {
    return {
      dataName: "取置データ",
      behavior: "取込",
      dateKey: "toriokiUpdatedAt",
    };
  },
  quarterZaiko: function () {
    return {
      dataName: "在庫データ",
      behavior: "取込",
      dateKey: "zaikoUpdatedAt",
    };
  },
  isFetchedHenpinDenpyou: function () {
    return {
      dataName: "返品伝票データ",
      behavior: "取込",
      dateKey: "henpinDenpyouUpdatedAt",
    };
  },
  isFetchedNouhinenpyou: function () {
    return {
      dataName: "納品伝票データ",
      behavior: "取込",
      dateKey: "nouhinDenpyouUpdatedAt",
    };
  },
};
const getBatchSchedule = async () => {
  try {
    batchSchedule.value.splice(0);
    const res: AxiosResponse<BatchSchedule> = await axios.get(
      `${store.getters["getBaseUrl"]}/completeBatch`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );

    // 取得した値をテーブル表示用に加工する
    Object.keys(res.data).forEach((key) => {
      if (batchInfo[key as keyof BatchInfo] !== undefined) {
        let showBatchInfo = {} as ShowBatchSchedule;
        let statusName = "";
        // 未処理の場合
        if (res.data[key] === 0) {
          statusName = "未処理";
        }
        // 取置・在庫データの場合
        else if (key === "quarterZaiko" || key === "quarterTorioki") {
          if (res.data[key] === 5) {
            statusName = "失敗";
          } else {
            statusName = "成功";
          }
        }
        // それ以外
        else {
          if (res.data[key] === 1) {
            statusName = "成功";
          }
          if (res.data[key] === 2) {
            statusName = "失敗";
          }
          if (res.data[key] === 3) {
            statusName = "データなし";
          }
        }

        const getBatchInfo = batchInfo[key as keyof BatchInfo]();
        const batchDate =
          res.data[getBatchInfo.dateKey] !== null
            ? (res.data[getBatchInfo.dateKey] as string).replace("-", "/")
            : "";
        showBatchInfo = {
          behavior: getBatchInfo.behavior,
          dataName: getBatchInfo.dataName,
          date: batchDate,
          statusNumber: res.data[key] as number,
          statusName: statusName,
        };
        batchSchedule.value.push(showBatchInfo);
      }
    });
  } catch (error) {
    alert("バッチスケジュールを取得できませんでした");
    console.log(error);
  }
};
getBatchSchedule();

// 一定時間ごとにバッチ状況を取得する
let timer = 0;
const stopTimer = () => {
  clearInterval(timer);
};
const startTimer = () => {
  if (timer) {
    clearInterval(timer);
  }
  timer = setInterval(() => multiMethodForTimer(), ms);
};
startTimer();

onBeforeUnmount(() => {
  stopTimer();
});

const badgeColor = computed(() => (statusName: string) => {
  let returnData = "";
  if (statusName === "未処理") returnData = "badge_blue";
  if (statusName === "成功") returnData = "badge_green";
  if (statusName === "失敗") returnData = "badge_red";
  if (statusName === "データなし") returnData = "badge_gray";
  return returnData;
});

// ユーザー操作ログの取得-----------------------------------------------------
const operationLogList = ref([
  {
    comments: "",
    headline: "",
    processingTime: "",
    userName: "",
    uuid: "",
  },
]);
const getOperationLog = async () => {
  try {
    const res: AxiosResponse<OperationLogList[]> = await axios.get(
      `${store.getters["getBaseUrl"]}/completeBatch/operation-log`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    operationLogList.value.splice(0);
    res.data.forEach((res) => {
      operationLogList.value.push(res);
    });
  } catch (error) {
    console.log(error);
    alert("操作ログが取得できませんでした");
  }
};
getOperationLog();
// 日付を表示用に変換
const convertDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    // const year = targetDate.getFullYear();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
    const day = targetDate.getDate().toString().padStart(2, "0");
    const hours = targetDate.getHours().toString().padStart(2, "0");
    const minutes = targetDate.getMinutes().toString().padStart(2, "0");
    const seconds = targetDate.getSeconds().toString().padStart(2, "0");
    return `${month}/${day} ${hours}:${minutes}:${seconds}`;
  } else {
    return null;
  }
};

// ログ参照
const headlineGroup = [
  {
    type: "chosei",
    url: "/chosei/orderList-log",
    headlines: ["調整数編集"],
  },
  {
    type: "juchu",
    url: "/chumonReference/normalDetails-from-dashboard",
    headlines: ["通常受注登録", "マルチ受注登録", "受注修正", "受注削除"],
  },
  {
    type: "orderHold",
    url: "/chumonReference/normalDetails-hold-from-dashboard",
    headlines: ["受注保留解除"],
  },
  {
    type: "chumonList",
    url: "/compile/list-detail-display-log",
    headlines: ["注文リスト作成", "注文リスト編集", "注文リスト削除"],
  },
  {
    type: "orderOutOfStock",
    url: "/orderOutOfStock/display-from-dashborad",
    headlines: ["品切れ保留編集"],
  },
  {
    type: "preChumonList",
    url: "/pre/chumon/get-detail-log",
    headlines: [
      "事前注文リスト作成",
      "事前注文リスト編集",
      "事前注文リスト削除",
    ],
  },
  {
    type: "itemRemarks",
    url: "/syosi/log-remarks",
    headlines: ["商品備考入力"],
  },
  {
    type: "updateStatus",
    url: "/syosi/log-status",
    headlines: ["VAN強制ステータス入力"],
  },
  {
    type: "orderProductSimulation",
    url: "/zaiko-simulation/log-order",
    headlines: ["在庫シミュレーション登録・編集"],
  },
  {
    type: "confirmProductSimulation",
    url: "/zaiko-simulation/log-confirm",
    headlines: ["在庫シミュレーション確定"],
  },
  {
    type: "editProductStatus",
    url: "/syosi/display-from-dashborad",
    headlines: ["商品ステータス編集"],
  },
];
const referLog = async (log: OperationLogList) => {
  let targetHeadline = {} as HeadlineGroup;
  let url = "";
  for (let headlineInfo of headlineGroup) {
    if (headlineInfo.headlines.includes(log.headline)) {
      targetHeadline = headlineInfo;
      url = `${store.getters["getBaseUrl"]}${headlineInfo.url}?uuid=${log.uuid}`;
      break;
    }
  }
  if (url !== "") {
    try {
      console.log(url);
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      const resData = res.data;
      // console.log(resData);

      if (
        targetHeadline.type === "juchu" ||
        targetHeadline.type === "orderHold"
      ) {
        let resolvedRoute = router.resolve({
          name: "OrderConfirmEdit",
          params: { id: resData.juchuId },
          query: {
            isActiveNormal: 1,
            isLogMode: 0,
            isActiveReference: 1,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "chosei") {
        let resolvedRoute = router.resolve({
          name: "OrderAdjustmentDetail",
          query: {
            isLogMode: 1,
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "chumonList") {
        let resolvedRoute = router.resolve({
          name: "CreateNewList",
          params: { id: resData.listId },
          query: {
            fromDashboard: 1,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "orderOutOfStock") {
        const times = log.comments.substring(0, log.comments.indexOf("回"));
        const updateTime = new Date(log.processingTime);
        const year = updateTime.getFullYear();
        const month = updateTime.getMonth() + 1;
        const day = updateTime.getDate();

        let resolvedRoute = router.resolve({
          name: "OrderOutOfStockLog",
          query: {
            uuid: log.uuid,
            times: times,
            updateTime: `${year}/${month}/${day}`,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "preChumonList") {
        let resolvedRoute = router.resolve({
          name: "NewPreOrderList",
          params: { id: resData.id },
          query: {
            fromDashboard: 1,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "itemRemarks") {
        let resolvedRoute = router.resolve({
          name: "ItemRemarksLog",
          query: {
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "updateStatus") {
        let resolvedRoute = router.resolve({
          name: "UpdateStatusLog",
          query: {
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "orderProductSimulation") {
        let resolvedRoute = router.resolve({
          name: "ProductSimulationLog",
          query: {
            isConfirm: 0,
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "confirmProductSimulation") {
        let resolvedRoute = router.resolve({
          name: "ProductSimulationLog",
          query: {
            isConfirm: 1,
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      } else if (targetHeadline.type === "editProductStatus") {
        let resolvedRoute = router.resolve({
          name: "EditProductStatusLog",
          query: {
            uuid: log.uuid,
          },
        });
        window.open(
          resolvedRoute.href,
          "_blank",
          "width=1000,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
            (window.screen.width - 1000) / 2 +
            ",top=" +
            (window.screen.height - 650) / 2
        );
      }
    } catch (error) {
      console.log(error);
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        notyf.error({
          duration: 5000,
          message: "参照可能なデータがありません",
        });
      }
    }
  }
};

// （仮）未対応のボタンをグレーアウトさせる
const disabledButton = (headline: string) => {
  const availableHeadline = [
    "調整数編集",
    "通常受注登録",
    "マルチ受注登録",
    "受注修正",
    "受注削除",
  ];
  if (
    availableHeadline.find((available) => {
      return available === headline;
    }) !== undefined
  ) {
    return "available-btn";
  } else {
    return "disabled-btn";
  }
};

// タイマーでまとめて二つのメソッドを実行する---------------------------
const multiMethodForTimer = () => {
  getBatchSchedule();
  getOperationLog();
};

// お知らせの取得------------------------------------------------------
// 最新5件のお知らせを取得
const latestInformation = ref([
  {
    contents: "",
    id: -1,
    registeredAt: "",
    scheduledEndAt: "",
    scheduledStartAt: "",
    title: "",
    isOpen: false,
  },
]);
const getLatestInformation = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/information/latest`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    latestInformation.value.splice(0);
    latestInformation.value = res.data;
    latestInformation.value.forEach((info) => {
      info.isOpen = false;
    });
  } catch (error) {
    console.log(error);
    alert("最新お知らせを取得できませんでした");
  }
};
getLatestInformation();
// 表示用日付生成
const convertOnlyDate = (registerDate: string | null) => {
  if (typeof registerDate === "string") {
    const targetDate = new Date(registerDate);
    const year = targetDate.getFullYear();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, "0");
    const date = targetDate.getDate().toString().padStart(2, "0");
    return `${year}/${month}/${date}`;
  } else {
    return null;
  }
};
// 未読お知らせモーダル---------------
// 未読お知らせの取得
const unreadInfo = ref([] as InformationList[]); // 未読お知らせ一覧
const getUnreadInfo = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/information/unread`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    unreadInfo.value = res.data;
    unreadInfoNum.value = unreadInfo.value.length;
    if (unreadInfo.value.length > 0) {
      openInfoModal();
    }
  } catch (error) {
    console.log(error);
    alert("未読お知らせを取得できませんでした");
  }
};
getUnreadInfo();
// モーダル関連
const infoModalVisible = ref(false);
const displayingUnreadInfo = ref({} as InformationList);
const unreadInfoNum = ref(0); // 未読お知らせ総数
const displayingUnreadInfoNum = ref(1); // 表示中の未読お知らせ番号
const openInfoModal = () => {
  displayingUnreadInfo.value = unreadInfo.value[0];
  infoModalVisible.value = true;
};
const closeInfoModal = async (id: number | null) => {
  infoModalVisible.value = false;
  // 確認ボタンから閉じられた場合既読にする
  if (id !== null) {
    try {
      await axios.post(
        `${store.getters["getBaseUrl"]}/information/check?generalInformationId=${id}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
    } catch (error) {
      console.log(error);
      alert("既読チェックに失敗しました");
    }
  }
  // 表示済みお知らせを削除
  unreadInfo.value.splice(0, 1);
  // 未読お知らせがある場合は再度モーダルを表示
  if (unreadInfo.value.length > 0) {
    displayingUnreadInfoNum.value++;
    openInfoModal();
  }
};

// 講談社用表示制御
const storeUserData = computed(() => {
  return store.getters["login/getUserData"];
});
const isKodansha = computed(() => {
  return storeUserData.value.hanmotoCd == "2253";
});
//ぱんくずヘッダー
const currentPathList = [{ name: "ダッシュボード" }];

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_slide_up_down = _resolveComponent("slide-up-down")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (infoModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
        : _createCommentVNode("", true),
      (infoModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'xmark'],
                class: "xmark",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (closeInfoModal(null)))
              }),
              _createElementVNode("p", _hoisted_4, " 未読のお知らせ（" + _toDisplayString(displayingUnreadInfoNum.value) + "/" + _toDisplayString(unreadInfoNum.value) + "） ", 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(convertOnlyDate(displayingUnreadInfo.value.registeredAt)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(displayingUnreadInfo.value.title), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "info_content user_info_content",
                  innerHTML: displayingUnreadInfo.value.contents
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "btn_green",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (closeInfoModal(displayingUnreadInfo.value.id)))
                }, [
                  _createTextVNode(" 確認"),
                  _hoisted_11,
                  _hoisted_12
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createElementVNode("div", {
      class: _normalizeClass(["syoten_kirikae", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
    }, " ようこそ、" + _toDisplayString(_unref(store).getters["login/getLoginSyotenName"]) + "様 ", 3),
    _createElementVNode("div", {
      class: _normalizeClass(["Dashboard", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
    }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            onClick: toggleInfoArea,
            class: "Dashboard_Contents_Header"
          }, [
            (_unref(isActiveInfo))
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  class: "Dashboard_Contents_Icon",
                  icon: "angle-up"
                }))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  class: "Dashboard_Contents_Icon",
                  icon: "angle-down"
                })),
            _hoisted_15
          ]),
          (_unref(isActiveInfo))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                (latestInformation.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, " お知らせがありません "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latestInformation.value, (info) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: info.id,
                          onClick: ($event: any) => (info.isOpen = !info.isOpen),
                          class: "Info_Contents"
                        }, [
                          _createElementVNode("h4", _hoisted_20, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(convertOnlyDate(info.registeredAt)), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_22, _toDisplayString(info.title), 1)
                            ])
                          ]),
                          _createVNode(_component_slide_up_down, {
                            active: info.isOpen,
                            duration: 500
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "info_content user_info_content",
                                innerHTML: info.contents
                              }, null, 8, _hoisted_23)
                            ]),
                            _: 2
                          }, 1032, ["active"])
                        ], 8, _hoisted_19))
                      }), 128)),
                      _createVNode(BtnGreen, {
                        onClickBtn: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/informationDetail'))),
                        class: "Info_Btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("もっと見る")
                        ]),
                        _: 1
                      })
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", {
              onClick: toggleBatchArea,
              class: "Dashboard_Contents_Header"
            }, [
              (_unref(isActiveBatch))
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    class: "Dashboard_Contents_Icon",
                    icon: "angle-up"
                  }))
                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    class: "Dashboard_Contents_Icon",
                    icon: "angle-down"
                  })),
              _hoisted_26
            ]),
            (_unref(isActiveBatch))
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("table", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(batchSchedule.value, (batch, batchIndex) => {
                          return (_openBlock(), _createElementBlock("tr", { key: batchIndex }, [
                            _createElementVNode("td", null, _toDisplayString(batch.date), 1),
                            _createElementVNode("td", null, _toDisplayString(batch.dataName), 1),
                            _createElementVNode("td", null, _toDisplayString(batch.behavior), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", badgeColor.value(batch.statusName)])
                              }, _toDisplayString(batch.statusName), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!isKodansha.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", {
                  onClick: toggleCalendarArea,
                  class: "Dashboard_Contents_Header"
                }, [
                  (_unref(isActiveCalendar))
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        class: "Dashboard_Contents_Icon",
                        icon: "angle-up"
                      }))
                    : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 1,
                        class: "Dashboard_Contents_Icon",
                        icon: "angle-down"
                      })),
                  _hoisted_34
                ]),
                (_unref(isActiveCalendar))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("table", _hoisted_37, [
                          _hoisted_38,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationLogList.value, (log, logIndex) => {
                              return (_openBlock(), _createElementBlock("tr", { key: logIndex }, [
                                _createElementVNode("td", null, _toDisplayString(convertDate(log.processingTime)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("p", _hoisted_39, _toDisplayString(log.headline), 1),
                                  _createElementVNode("p", null, _toDisplayString(log.comments), 1)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(log.userName), 1),
                                _createElementVNode("td", null, [
                                  (!log.headline.includes('【バッチ処理】'))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: ($event: any) => (referLog(log)),
                                        class: "available-btn"
                                      }, " 参照 ", 8, _hoisted_40))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        (operationLogList.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, " ログがありません "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})